module.exports = __webpack_public_path__ + "static/media/notification-sound.66b16d04.mp3";